import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import IconButton from 'components/ui/Button/IconButton';
import useAppSelector from 'hooks/useAppSelector';
import { selectFont, selectLang, selectToken, selectVerified } from 'store/reducers/shopSlice';
import { WorkerInputSearchParams } from './export.worker';
import { PdfDocumentData } from './exportPdfTypes';
import { startExport } from './ExportPdfWorker';

type ExportPdfButtonProps = {
    data: PdfDocumentData;
    productSearchParams: WorkerInputSearchParams;
};

const ExportPdfButton = ({ data, productSearchParams }: ExportPdfButtonProps) => {
    const verified = useAppSelector(selectVerified);
    const token = useAppSelector(selectToken);
    const lang = useAppSelector(selectLang);
    const font = useAppSelector(selectFont);

    return (
        <IconButton
            square
            bgColor="fillWhite"
            icon={faDownload}
            onClick={() => {
                startExport({
                    data: {
                        ...data,
                        settings: {
                            useCompactLayout: false,
                            ...data.settings,
                        },
                    },
                    productSearchParams,
                    token: verified ? token : undefined,
                    lang,
                    font,
                });
            }}
        >
            PDF
        </IconButton>
    );
};

export default ExportPdfButton;
